



const GET_CODE = 'code/GET_CODE';
const RESET_CODE = 'code/RESET_CODE';



export {
  GET_CODE,
  RESET_CODE,

};
